import { PaperClipOutlined, TagOutlined } from "@ant-design/icons";
import { ReactComponent as AccountSettingsIcon } from "../../assets/AccountSettingsIcon.svg";
import { ReactComponent as ProductsIcon } from "../../assets/ProductsIcon.svg";
import { ReactComponent as SupportIcon } from "../../assets/SupportIcon.svg";
import { ReactComponent as SignoutIcon } from "../../assets/SignOutIcon.svg";

import { useAuth } from "../hooks/useAuth";
import { GetProp, MenuProps, Tooltip } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

export const useSideBarMenu = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [open, setOpen] = useState(false);

  type MenuItem = GetProp<MenuProps, "items">[number];

  const handleMenuClick = (url: string) => {
    if (url === "Support") {
      window.location.href = "mailto:support@docupdate.io";
    } else {
      navigate(url);
    }
    setOpen(false);
  };

  const handleNavMenuClick = (url: string) => {
    window.open(url, "_blank");
  };

  const MENU_INFO: MenuItem[] = [
    {
      key: "1",
      label: <Tooltip title="Account Setting">Account Setting</Tooltip>,
      icon: <AccountSettingsIcon className="w-full object-cover max-w-10" />,
      onClick: () => handleMenuClick("/advisory-board-portal-new"),
      className:
        "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white",
    },
    {
      key: "2",
      label: "Products",
      icon: <ProductsIcon className="w-full object-cover max-w-10" />,
      children: [
        {
          key: "21",
          label: <Tooltip title="Advisory Board">Advisory Board</Tooltip>,
          icon: <TagOutlined className="w-full object-cover max-w-5" />,
          className:
            "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white product-menu",
          onClick: () => handleMenuClick("/advisory-board-new"),
        },
        {
          key: "22",
          label: <Tooltip title="Prescriber App">Prescriber App</Tooltip>,
          icon: <PaperClipOutlined className="w-full object-cover max-w-5" />,
          className:
            "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white product-menu",
          onClick: () => handleMenuClick("/ePrescribe"),
        },
      ],
    },
    {
      key: "3",
      label: "Support",
      icon: <SupportIcon className="w-full object-cover max-w-10" />,
      className:
        "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white",
      onClick: () => handleMenuClick("Support"),
    },
    {
      key: "4",
      label: "Sign Out",
      icon: <SignoutIcon className="w-full object-cover max-w-10" />,
      className:
        "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white",
      onClick: () => logout(),
    },
  ];

  const MENU_INFO_MOBILE: MenuItem[] = [
    {
      key: "1",
      label: "Account Setting",
      icon: <AccountSettingsIcon className="w-full object-cover max-w-10" />,
      onClick: () => handleMenuClick("/advisory-board-portal-new"),
      className:
        "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white",
    },
    {
      key: "2",
      label: "Products",
      icon: <ProductsIcon className="w-full object-cover max-w-10" />,
      children: [
        {
          key: "21",
          label: "Advisory Board",
          icon: <TagOutlined className="w-full object-cover max-w-5" />,
          className:
            "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white product-menu",
          onClick: () => handleMenuClick("/advisory-board-new"),
        },
        {
          key: "22",
          label: "Prescriber App",
          icon: <PaperClipOutlined className="w-full object-cover max-w-5" />,
          className:
            "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white product-menu",
          onClick: () => handleMenuClick("/ePrescribe"),
        },
      ],
    },
    {
      key: "3",
      label: "Support",
      icon: <SupportIcon className="w-full object-cover max-w-10" />,
      className:
        "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white",
      onClick: () => handleMenuClick("Support"),
    },
    {
      key: "4",
      label: "Sign Out",
      icon: <SignoutIcon className="w-full object-cover max-w-10" />,
      className:
        "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white",
      onClick: () => logout(),
    },
  ];

  const NAVBAR_INFO_MOBILE: MenuItem[] = [
    {
      key: "tools",
      label: "Our Tools",
      className:
        "font-playfair text-2xl bg-transparent text-[#101935] product-menu hover:bg-[#E9EAEB]",
      children: [
        {
          key: "tools-1",
          label: "Prescriber",
          className:
            "flex items-center font-playfair text-xl bg-transparent text-[#101935] product-menu hover:bg-[#E9EAEB]",
          onClick: () =>
            handleNavMenuClick("https://www.docupdate.io/prescriber/"),
        },
        {
          key: "tools-2",
          label: "AI Medical Translator",
          className:
            "flex items-center font-playfair text-xl bg-transparent text-[#101935] product-menu hover:bg-[#E9EAEB]",
          onClick: () =>
            handleNavMenuClick("https://www.docupdate.io/translator/"),
        },
        {
          key: "tools-3",
          label: "Concierge",
          className:
            "flex items-center font-playfair text-xl bg-transparent text-[#101935] product-menu hover:bg-[#E9EAEB]",
          onClick: () =>
            handleNavMenuClick("https://www.docupdate.io/concierge/"),
        },
      ],
    },
    {
      key: "articles",
      label: "Articles",
      className:
        "font-playfair text-2xl bg-transparent text-[#101935] product-menu hover:bg-[#E9EAEB]",
      onClick: () =>
        handleNavMenuClick("https://www.docupdate.io/articles/"),
    },
    {
      key: "about",
      label: "About Us",
      className:
        "font-playfair text-2xl bg-transparent text-[#101935] product-menu hover:bg-[#E9EAEB]",
      onClick: () =>
        handleNavMenuClick("https://www.docupdate.io/about-us/"),
    },
    {
      key: "preferences",
      label: "Manage Preferences",
      className:
        "font-playfair text-2xl bg-transparent text-[#101935] product-menu hover:bg-[#E9EAEB]",
      onClick: () =>
        handleNavMenuClick("https://www.docupdate.io/manage-preferences/"),
    },
  ];

  const POPUP_CONTENT = (
    <div className="wp-popover">
      <Link
        to={"https://www.docupdate.io/prescriber/"}
        className="wp-popover__item"
      >
        <div className="wp-popover__title">Prescriber</div>
        <div className="wp-popover__desc">Prescriptions, sent in seconds.</div>
      </Link>
      <Link
        to={"https://www.docupdate.io/translator/"}
        className="wp-popover__item"
      >
        <div className="wp-popover__title">AI Medical Translator</div>
        <div className="wp-popover__desc">
          20+ language medical interpreter in your pocket.
        </div>
      </Link>
      <Link
        to={"https://www.docupdate.io/concierge/"}
        className="wp-popover__item wp-popover__item--last"
      >
        <div className="wp-popover__title">Concierge</div>
        <div className="wp-popover__desc">
          Direct access to reps, samples and patient support.
        </div>
      </Link>
    </div>
  );

  return {
    MENU_INFO,
    MENU_INFO_MOBILE,
    NAVBAR_INFO_MOBILE,
    POPUP_CONTENT,
    open,
    setOpen,
  };
};